import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, Modal, Select, Space, Table, Tooltip } from "antd";
import "./adjustment.css";
import { IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { RiFileCloseFill } from "react-icons/ri";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { FaPlusCircle } from "react-icons/fa";
import { useAdjustmentTable } from "./hoc_adjustment";
import AdjustmentADDEDITITEMLIST from "./add_edit_list_item";
export const EVENT_OPTIONS = [
    { label: "— Empty —-", value: "" },
    { label: "Adjust retur pembelian part", value: "1" },
    { label: "Adjustment Item Class", value: "2" },
    { label: "Adjustment selisih inventory part", value: "3" },
    { label: "Pengakuan HPP Kaca film (migrasi)", value: "4" },
];


const Adjustment: React.FC = () => {
    const {
        tableData,
        columns,
        rowSelection,
        form,
        warehouses,
        brands,
        handleWhChange,
        isWhDisabled,
        isModalVisible,
        setIsModalVisible,
        handleSelectItem,
        handleDelete,
        autosaveStatus,
        debouncedSaveHeader,
        handleNew,
        handleVoid,
        selectedRowKeys,
        handleSubmit,
        isConfirmModalVisible,
        setIsConfirmModalVisible,
        remark,
        handleRemarkChange,
        handleConfirmSubmit
    } = useAdjustmentTable();
    const currentStatus = Form.useWatch('status', form);
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Newbtn = FaPlusCircle as React.ComponentType<any>;
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Closebtn = RiFileCloseFill as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const AddLine = FaPlusCircle as React.ComponentType<any>;
    const Deletebtn = IoIosCloseCircleOutline as React.ComponentType<any>;

    return (

        <div id="ia7c" style={transformStyle}>
            <div className="gjs-grid-row" id="imzco">
                <div className="gjs-grid-column" id="ic7y2">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_adjustment",
                                title: (
                                    <>
                                        <span style={{ fontWeight: '200', color: 'rgba(0, 0, 0, 0.88)' }}>Data Adjustment</span>
                                    </>
                                ),
                            },
                            {
                                title: "Adjustment",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="ijk1k">
                <div className="gjs-grid-column" id="ig6fp">
                    <Button className="gr-button" onClick={handleNew}>
                        <Newbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button" onClick={handleSubmit} disabled={currentStatus === "Approved"}>
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                    <Button className="gr-button" onClick={handleVoid} disabled={currentStatus !== "Draft"}>
                        <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Void
                    </Button>
                    <Button className="gr-button" >
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="ijj2g">
                <div className="gjs-grid-column" id="immjp">
                    <Form
                        form={form}
                        onValuesChange={(_, allValues) => debouncedSaveHeader(allValues)}
                        layout="horizontal"
                        style={{ maxWidth: 400 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Adjustment No"
                            name="adjustment_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Adjusmnet Date"
                            name="adjustment_date"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Brand"
                            name="brand"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={brands}

                            />
                        </Form.Item>
                        <Form.Item
                            label="Event No"
                            name="event_no"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                popupMatchSelectWidth={false}
                                options={EVENT_OPTIONS}

                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                popupMatchSelectWidth={false}
                                options={warehouses}
                                onChange={handleWhChange}
                                disabled={isWhDisabled}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="ifkbq">
                <div className="gjs-grid-column" id="iqiwo">
                    <Button className="gr-button" onClick={() => setIsModalVisible(true)}>
                        <AddLine style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Add Line
                    </Button>
                    <Button className="gr-button" onClick={handleDelete} disabled={selectedRowKeys.length === 0}>
                        <Deletebtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Delete
                    </Button>
                    <Table columns={columns} dataSource={tableData} rowSelection={rowSelection} pagination={{ pageSize: 10 }} />
                </div>
            </div>
            <Modal title="Add Item" open={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={null} width={800}>
                <AdjustmentADDEDITITEMLIST warehouse={form.getFieldValue('warehouse')} onSelect={handleSelectItem} />
            </Modal>
            <Modal
                title="Confirm Submission"
                open={isConfirmModalVisible}
                onOk={handleConfirmSubmit}
                onCancel={() => setIsConfirmModalVisible(false)}
            >
                <p>Are you sure you want to submit this adjustment?</p>
                <Input.TextArea
                    rows={4}
                    value={remark}
                    onChange={handleRemarkChange}
                />
            </Modal>
        </div>
    );
};

export default Adjustment;
